const ACCESS_KEY = 'aidu.admin.accessToken';
const REFRESH_KEY = 'aidu.admin.refreshToken';

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  refreshExpiresIn: number;
}

let memoryAccess: string | null = null;

export const tokenStorage = {
  getAccess(): string | null {
    return memoryAccess;
  },
  getRefresh(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY);
    } catch {
      return null;
    }
  },
  set(tokens: AuthTokens): void {
    memoryAccess = tokens.accessToken;
    try {
      localStorage.setItem(ACCESS_KEY, tokens.accessToken);
      localStorage.setItem(REFRESH_KEY, tokens.refreshToken);
    } catch {
      /* storage unavailable — access token still kept in memory */
    }
  },
  hydrateFromStorage(): void {
    try {
      memoryAccess = localStorage.getItem(ACCESS_KEY);
    } catch {
      memoryAccess = null;
    }
  },
  clear(): void {
    memoryAccess = null;
    try {
      localStorage.removeItem(ACCESS_KEY);
      localStorage.removeItem(REFRESH_KEY);
    } catch {
      /* ignore */
    }
  },
};
